import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NebularModule } from '../../../modules/nebular/nebular.module';

@Component({
  standalone: true,
  selector: 'ngx-error-field',
  templateUrl: './error-field.component.html',
  styleUrls: ['./error-field.component.scss'],
  imports: [CommonModule, NebularModule],
})
export class ErrorFieldComponent {
  @Input() control: any;
  @Input() label?: string;
}
